/* eslint-disable no-use-before-define */

import React from "react";
import {
  ActivityIndicator,
  Animated,
  Button as RNButton,
  Platform,
  StyleSheet,
  Text,
  View,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { checkCustomer } from "../redux/actions/remediation";
import MenuButton from "../components/MenuButton";
import WebHeading from "../components/WebHeading";
import { errorColors, RepositColours, RepositStyles } from "../utils/styles";
import goTo from "../utils/goTo";
import Phone from "../utils/Phone";

const timeCircle = (
  <Icon name="exclamation-circle" size={14} color={errorColors.red} />
);
const questionCircle = (
  <Icon name="warning" size={14} color={errorColors.orange} />
);

const mapStateToProps = (state) => ({
  box: state.box,
  remediation: state.remediation,
});

const mapDispatchToProps = (dispatch) => {
  return {
    remediationActions: bindActionCreators({ checkCustomer }, dispatch),
  };
};

const formatDistance = (distance) => {
  if (distance > 1000) {
    return Math.trunc(distance / 1000) + "km";
  } else {
    return Math.trunc(distance) + "m";
  }
};

class AddressValidation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fadeAnim: new Animated.Value(0), // init opacity 0
      checked: true,
      manualSelect: false,
    };
  }

  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "Box Replacement",
  };

  componentDidMount() {
    if (Platform.OS !== "web") {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.props.remediationActions.checkCustomer(
            this.props.box.serialNumber,
            position.coords.latitude,
            position.coords.longitude
          );
        },
        (error) =>
          this.props.remediationActions.checkCustomer(
            this.props.box.serialNumber,
            null,
            null
          )
      );
    } else {
      this.props.remediationActions.checkCustomer(
        this.props.box.serialNumber,
        null,
        null
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.remediation.address === null &&
      nextProps.remediation.address !== null
    ) {
      Animated.timing(
        // Uses easing functions
        this.state.fadeAnim, // The value to drive
        { toValue: 1 } // Configuration
      ).start();
    }
  }

  render() {
    return this.props.remediation.address !== null ? (
      <View style={styles.wrapper}>
        <WebHeading title="Box Replacement" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flex: 1, maxWidth: 600, maxHeight: 600 }}>
            <View style={{ flex: 1, justifyContent: "center" }}>
              <View style={{ flex: 3, justifyContent: "space-around" }}>
                <Text style={[RepositStyles.headerText]}>Customer Address</Text>

                <Text style={[RepositStyles.paragraphText]}>
                  Based on the Reposit Box Serial Number, you should be at the
                  following address:
                </Text>
                <Text style={[RepositStyles.paragraphText]}>
                  {this.props.remediation.address.display_address_line_1 +
                    "\n" +
                    this.props.remediation.address.display_address_line_2}
                </Text>
                <Text style={[RepositStyles.paragraphText]}>
                  Not there? <Phone>Call Reposit on</Phone>
                </Text>
                {this.props.remediation.address.distance_meters === null ? (
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      marginBottom: 5,
                      color: errorColors.orange,
                    }}
                  >
                    {questionCircle} We're unable to detect your location.
                    Please make sure you're at the correct address.
                  </Text>
                ) : this.props.remediation.address.distance_meters > 500 ? (
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      marginBottom: 5,
                      color: errorColors.red,
                    }}
                  >
                    {timeCircle} We've detected you are{" "}
                    <Text style={{ fontWeight: "bold" }}>
                      {formatDistance(
                        this.props.remediation.address.distance_meters
                      )}{" "}
                      away
                    </Text>{" "}
                    from this address. Please make sure you're at the correct
                    address. If you are not then <Phone>call Reposit on</Phone>
                  </Text>
                ) : null}
              </View>
              <View style={{ flex: 1 }} />
              <View
                style={{
                  flex: 2,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <View style={{ width: 80 }}>
                  <RNButton
                    title="Next"
                    onPress={() => {
                      goTo(this.props.navigation, "ReplaceValidation");
                    }}
                    color={RepositColours.blue}
                  />
                </View>
                <Text style={RepositStyles.nextSub}>Validate Installation</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    ) : (
      <View style={styles.wrapper}>
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <ActivityIndicator size="large" />
          <Text style={{ ...styles.text, marginVertical: 20 }}>
            Loading customer
          </Text>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: { backgroundColor: "white", flex: 1 },
  heading: {
    marginHorizontal: 20,
  },
  headingText: { fontSize: 24, textAlign: "center", fontWeight: "300" },
  addressBox: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    marginHorizontal: 20,
    marginVertical: 5,
  },
  addressHeader: {
    marginHorizontal: 20,
    backgroundColor: "grey",
  },
  addressText: {
    color: "white",
    marginHorizontal: 10,
    marginVertical: 2,
    lineHeight: 25,
    fontWeight: "300",
  },
  text: {
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 10,
  },
  paraText: {
    textAlign: "left",
    fontSize: 18,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 30,
    marginTop: 20,
  },
  textInput: {
    fontSize: 20,
    borderWidth: Platform.OS === "android" ? 0 : 1,
    borderRadius: Platform.OS === "android" ? 0 : 5,
    height: Platform.OS === "android" ? 45 : 30,
    marginVertical: 10,
    marginHorizontal: 15,
  },
  bodyText: {
    marginTop: 10,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressValidation);



// WEBPACK FOOTER //
// ./src/containers/AddressValidation.js